module.exports = __webpack_public_path__ + "static/media/G-7.aad46037.jpg";